// extracted by mini-css-extract-plugin
export var acceptButton = "cookie-banner-module--acceptButton--c1024";
export var bannerWrapper = "cookie-banner-module--bannerWrapper--5687b";
export var buttonsInnerWrapper = "cookie-banner-module--buttonsInnerWrapper--44d94";
export var buttonsWrapper = "cookie-banner-module--buttonsWrapper--3dc5a";
export var declineButton = "cookie-banner-module--declineButton--b8828";
export var description = "cookie-banner-module--description--8f1e7";
export var descriptionWrapper = "cookie-banner-module--descriptionWrapper--1071b";
export var title = "cookie-banner-module--title--724f5";